import { Controller } from "stimulus";
import { csrfToken } from "@rails/ujs";
import Rails from "@rails/ujs";


export default class extends Controller {
  static targets = ["sendEmailButton"];

  confirmSendEmail(event) {
    // Check if the button is disabled
    if (event.target.classList.contains("disabled")) {
      return; // Do nothing if the button is disabled
    }

    this.emailId = event.target.dataset.walletEmailId;
    const modal = document.getElementById("email-confirmation-modal");
    modal.classList.add("show");
    modal.style.display = "block";
    document.body.classList.add("modal-open");
  }

  closeModal() {
    const modal = document.getElementById("email-confirmation-modal");
    modal.classList.remove("show");
    modal.style.display = "none";
    document.body.classList.remove("modal-open");
  }

  sendEmail() {
    this.sendEmailRequest(`/admin/payment_transactions/${this.emailId}/send_step_one_wallet_email`);
  }

  sendSecondEmail() {
    const walletEmailId = document.getElementById("email-confirmation-modal").dataset.walletEmailId;
    this.sendEmailRequest(`/admin/contracts/${walletEmailId}/send_step_two_wallet_email`);
  }

  notSendingEmail() {
    this.updateFlash({ notice: "Die Wallet-Versand-E-Mail wurde nicht an den Kunden gesendet. Der Vertragsstatus wurde aktualisiert" });
    this.closeModal();
    location.reload();
  }

  sendEmailRequest(url) {
    fetch(url, {
      method: "POST",
      headers: {
        "X-CSRF-Token": csrfToken(),
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => this.handleEmailResponse(data))
      .catch((error) => {
        alert("An error occurred while sending the email.");
        console.error(error);
      });
  }

  handleEmailResponse(data) {
    const emailButton = document.querySelector(`#send-email-btn[data-wallet-email-id='${this.emailId}']`);
    if (data.success && emailButton) {
      emailButton.textContent = "Wallet Email Versendet";
      emailButton.classList.add("disabled");
      emailButton.disabled = true; // Ensure the button is programmatically disabled
    }
    this.updateFlash(data.flash);
    this.closeModal();
    location.reload();
  }

  updateFlash(flashData) {
    const flashContainer = document.querySelector("#flash.d-block");
    flashContainer.innerHTML = ""; // Clear existing flash messages

    if (flashData) {
      Object.entries(flashData).forEach(([key, message]) => {
        const flashClass = key === "alert" ? "alert-danger" : "alert-success";
        const flashDiv = document.createElement("div");
        flashDiv.className = `alert ${flashClass}`;
        flashDiv.innerHTML = `<span>${message}</span>`;
        flashContainer.appendChild(flashDiv);
      });
    }
  }

  async updateTokenDispatchConfirmed(e) {
    e.preventDefault();

    const row = e.target.closest("tr");
    if (!row) return;

    const contractId = row.getAttribute("id");
    if (!contractId) return;

    const data = new FormData();
    data.append("contract[token_dispatch_confirmed]", e.target.checked);

    Rails.ajax({
      type: "POST",
      url: `/admin/contracts/${contractId}/update_token_dispatch_confirmed`,
      data
    });
  }
}
